const getHubspotApiUrl = (): string => {
    if (process.env.REACT_APP_USE_API_MOCK === 'true') {
        return process.env.REACT_APP_MOCK_API_URL as string;
    }

    return '/';
};

export default getHubspotApiUrl;
